import {
  getUserAgent,
  parsePskeyQQLogin,
  parseWechatLogin,
  session_dummy,
  ajax,
  objectAssign,
  getParam,
  jumpMqq,
  setSessionCookie,
  cookies
} from "@tencent/midas-util"
import cgiObj from "./cgi"
import * as mqqApi from "./mqq"
import * as helper from "../utils/helper"
import * as request from "../utils/request"
import report from "@tencent/midas-cgi/lib/logdata"
import * as reportDic from "../constants/report-dictionary"

/**
 * 刚打开页面获得页面 session
 * QQ or Wx
 * 提示用户在微信内打开
 */
export function getUserSession() {
  return new Promise(async (resolve, reject) => {
    if (getUserAgent().QQ) {
      const loginState = await parsePskeyQQLogin({ s_url: location.href })
      if (loginState) {
        resolve(loginState)
      } else {
        resolve(
          new session_dummy({
            openid: "xxx",
            openkey: "openkey"
          })
        )
      }
    } else if (getUserAgent().weixin) {
      const loginState = parseWechatLogin()
      if (loginState) {
        resolve(loginState)
      } else {
        resolve(
          new session_dummy({
            openid: "xxx",
            openkey: "openkey"
          })
        )
      }
    }
    // else {
    //   jumpMqq(location.href)
    //   // alert("提示用户在微信内打开")
    // }
  })
}

/**
 * 切换QQ账号获得 session
 */
export function getQQSession() {
  return new Promise(async (resolve, reject) => {
    const loginState = await parsePskeyQQLogin({ s_url: location.href })
    if (loginState) {
      resolve(loginState)
    } else {
      // reject()
      resolve(
        new session_dummy({
          openid: "xxx",
          openkey: "openkey"
        })
      )
    }
  })
}

/**
 * 获得QQ用户昵称
 */
export function getQQNickname() {
  return new Promise((resolve, reject) => {
    const params = {
      cmd: 1
    }
    cgiObj
      .request("wechatQuery", params)
      .then(res => {
        if (res.ret === 0) {
          resolve(res)
        }
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 根据exportkey获取微信豆登陆态参数
 * @param params { offer_id, export_key }
 */
export function getWxBeanLoginState(params) {
  return new Promise((resolve, reject) => {
    const env = helper.getEnv(getParam("sandbox"))
    const url = `https://${env}api.unipay.qq.com/trpc.unipay_svr.midas_invoice_get_wecoin_session.Svr/WecoinInvoiceVerify`
    if (!params.offer_id || !params.export_key || !getParam("wxAppid2")) {
      reject("offer_id, export_key, wxAppid2 不能为空")
    }
    request
      .ajax({
        url,
        data: params,
        type: "POST",
        contentType: "json",
        requestContentType: "application/json"
      })
      .then(res => {
        if (res.ret === 0) {
          report({
            21: reportDic.SUCC.WXBEAN_VERIFY_SUCC,
            31: getParam("version") || "MidasInvoiceDefaultVersion1.0",
            8: res
          })
          resolve({
            openid: res.open_id,
            openkey: res.open_key,
            session_id: "hy_gameid",
            session_type: "st_local_wechat",
            wx_appid: getParam("wxAppid2")
          })
        } else {
          report({
            21: reportDic.ERROR.WXBEAN_VERIFY_FAIL,
            31: getParam("version") || "MidasInvoiceDefaultVersion1.0",
            8: {
              params: JSON.stringify(params),
              err: JSON.stringify(res)
            }
          })
          reject(res)
        }
      })
      .catch(err => {
        report({
          21: reportDic.ERROR.WXBEAN_VERIFY_FAIL,
          31: getParam("version") || "MidasInvoiceDefaultVersion1.0",
          8: {
            params: JSON.stringify(params),
            err: JSON.stringify(err)
          }
        })
        reject(err)
      })
  })
}

/**
 * 获得WX用户昵称和头像
 */
export function getWechatNicknameAndAvatar(params) {
  return new Promise((resolve, reject) => {
    ajax({
      url: "//pay.qq.com/cgi-bin/account/get_wechat_userinfo.cgi",
      method: "POST",
      param: {
        get_detail: 2,
        openid: params.openid,
        access_token: encodeURIComponent(params.accessToken)
      },
      success: res => {
        if (res.resultcode === 0) {
          resolve(res.resultinfo)
        } else if (res.resultcode === 12273) {
          setSessionCookie({
            openid: "xxx",
            openkey: "openkey",
            sessionid: "hy_gameid",
            sessiontype: "st_dummy"
          })
          // 如果是外部传入登录态，不再重新加载页面
          if (!getParam("openid") || !getParam("openkey")) {
            location.reload()
          }
        }
      },
      error: err => {
        reject(err)
      }
    })
  })
}

/**
 * 获得QQ互联用户昵称和头像
 * https://graph.qq.com/user/get_user_info?access_token=0BEF1B136FEF536D712FD030F1A1F0BF&oauth_consumer_key=101502376&openid=F8CEC1A2A7AB0EC45B8D9E3331482A65
 */
export function getQQConnectNicknameAndAvatar(params) {
  return new Promise((resolve, reject) => {
    // let now = new Date().getTime()
    mqqApi
      .initQCJsApi()
      .then(QC => {
        QC.api("get_user_info", {
          access_token: encodeURIComponent(params.accessToken),
          oauth_consumer_key: params.appId,
          openid: params.openid
        })
          .success(response => {
            if (response && response.data && response.ret === 0) {
              resolve(response.data)
            } else {
              reject(response)
            }
          })
          .error(err => {
            reject(err)
          })
      })
      .catch(err => {
        reject(err)
      })

    // request
    //   .jsonp({
    //     url: "//graph.qq.com/user/get_user_info",
    //     data: {
    //       access_token: encodeURIComponent(params.accessToken),
    //       oauth_consumer_key: params.appId,
    //       openid: params.openid,
    //       format: "jsonp__qqconnect" + now
    //     },
    //     jsonpCallbackName: "_qqconnect" + now
    //   })
    //   .then(res => {
    //     resolve(res)
    //   })
    //   .catch(res => {
    //     reject(res)
    //   })
  })
}

/**
 * 获得微信用户是否关注腾讯充值公众号
 */
export function isFollowedOfficalWechatAccount() {
  return new Promise((resolve, reject) => {
    cgiObj
      .request("mobile_subscribe", {
        action: "query_follow"
      })
      .then(res => {
        if (res.ret === 0) {
          resolve(res.info.is_followed)
        } else {
          reject(res)
        }
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * @opt {Object} opt 需要上报的字段
 *     opt[21] 必传，iformat
 *     opt[8] resultinfo
 *     opt[7] 错误码，默认0，错误上报时可通过该字段区分错误类型
 */
export function reportLogData(opt) {
  const resultInfo = {
    ua: getUa(),
    resolution: getResolution()
  }
  opt[8] = objectAssign(resultInfo, opt[8] || {})
  cgiObj.logData(opt)
}

/**
 * ua判断SQ/WX
 * @returns {*}
 */
export const isWX = () => {
  return !!getUserAgent().weixin
}

export const isQQ = () => {
  return !!getUserAgent().QQ
}

export const isAndroid = () => {
  return !!getUserAgent().android
}

export const isIOS = () => {
  return !!getUserAgent().iOS
}

export const isWxMini = () => {
  return !!getUserAgent().weixinminiprogram
}

/**
 * 获得当前用户 ua
 * @returns {*}
 */
export const getUa = () => {
  const ua = getUserAgent()
  const isWX = ua.weixin
  const isQQ = ua.QQ
  const isAndroid = ua.android
  const isIos = ua.iOS

  if (isAndroid && isWX) {
    return "android_" + isAndroid + "&wx_" + isWX
  }

  if (isAndroid && isQQ) {
    return "android_" + isAndroid + "&qq_" + isQQ
  }

  if (isIos && isWX) {
    return "ios_" + isIos + "&wx_" + isWX
  }

  if (isIos && isQQ) {
    return "ios_" + isIos + "&qq_" + isQQ
  }

  return ""
}

/**
 * 获得手机分辨率
 * @returns {*}
 */
export const getResolution = () => {
  return window.screen.width + "X" + window.screen.height
}

export const getDevice = () => {
  const uaDevice = new uaDevice(navigator.userAgent)
  if (uaDevice) {
    if (uaDevice.device) {
      return uaDevice.device.manufacturer + " " + uaDevice.device.model
    }
    return ""
  }
  return ""
}

export const getSessionType = sessionObj => {
  let sessiontype = sessionObj.getSessionParam().session_type
  switch (true) {
    case helper.isQQSessionType(sessiontype):
      return "qq"

    case sessiontype === "wc_actoken":
      return "wx"

    case sessiontype === "st_dummy":
      return "dummy"

    default:
      return 0
  }
}

export function getWxBeanSessionCookie() {
  let openid = cookies.get("midas_txcz_openid")
  let openkey = cookies.get("midas_txcz_openkey")
  let sessionid = cookies.get("midas_txcz_sessionid")
  let sessiontype = cookies.get("midas_txcz_sessiontype")

  let wxAppid2 = cookies.get("midas_txcz_wxAppid2")

  if (!openid || !openkey) {
    return false
  }

  if (sessiontype !== "st_local_wechat") {
    return false
  }

  return {
    openid,
    openkey,
    session_id: "hy_gameid",
    session_type: "st_local_wechat",
    wx_appid: wxAppid2
  }
}

export function setWxBeanSessionCookie({ openid, openkey, session_id, session_type, wx_appid }) {
  cookies.set("midas_txcz_openid", openid, { sessionCookie: true })
  cookies.set("midas_txcz_openkey", openkey, { sessionCookie: true })
  cookies.set("midas_txcz_sessionid", session_id, { sessionCookie: true })
  cookies.set("midas_txcz_sessiontype", session_type, { sessionCookie: true })

  if (wx_appid) {
    cookies.set("midas_txcz_wxAppid2", wx_appid, { sessionCookie: true })
  }
}
